class Iframes {

    // Constructor
    constructor() {
        this.autoHeight();
        this.fullScreen();
    }

    // Iframe auto height
    autoHeight() {
        let windowHeight = $(window).height();
        let headerHeight = $('header').height();
        let bottomNavHeight = 0;

        if ($('.nav-mobile-1').length > 0) {
            bottomNavHeight = $('.nav-mobile-1').height();
        }

        let iframeHeight = windowHeight - headerHeight - bottomNavHeight;
        $('#iframe').attr('height', iframeHeight);
    }

    fullScreen() {
        $(document).on('click', '#full-screen', function() {
            let $element = document.getElementById('iframe');

            if ($element.requestFullscreen) {
                $element.requestFullscreen();

            } else if ($element.webkitRequestFullscreen) {
                $element.webkitRequestFullscreen();

            } else if ($element.msRequestFullscreen) {
                $element.msRequestFullscreen();
            }
        });
    }
}

window.Iframes = Iframes;